module.exports = __webpack_public_path__ + "media/images/page/voice_illust02-b309672d699cc5174d4b936b6614bbc3.png";